import { useState } from 'react';
import useUpdateNode from '@pages/schemes/hooks/useUpdateNode';
import { useTranslation } from 'react-i18next';

const formatNodeName = (name) => (name ? name.replace(/[_-]/g, ' ') : '');

const HiddenNodeNameInput = ({ nodeId, nodeData, nodeSelected }) => {
    const { t } = useTranslation();
    const updateNode = useUpdateNode();
    const [nodeName, setNodeName] = useState(formatNodeName(nodeData.name));
    const hasBottomBorderPort =
        Boolean(nodeData.ports_positions) &&
        Object.values(nodeData.ports_positions).find((value) => value.reactflow_position === 'bottom');

    const handleChange = (e) => {
        const newName = e.target.value;
        setNodeName(newName);
        updateNode(nodeId, { name: newName });
    };

    return (
        <input
            title={nodeName}
            value={nodeName}
            onChange={handleChange}
            type="text"
            placeholder={nodeSelected ? `${t('enter')} ${t('name').toLowerCase()}...` : ''}
            spellCheck="false"
            style={{
                position: 'absolute',
                bottom: hasBottomBorderPort ? -25 : -15,
                left: '-50%',
                width: '200%',
                background: 'transparent',
                border: 'none',
                outline: 'none',
                boxShadow: 'none',
                padding: 0,
                margin: 0,
                textAlign: 'center',
                fontSize: '0.5rem',
                color: 'inherit',
                lineHeight: 'inherit',
                caretColor: 'auto',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            }}
        />
    );
};

export default HiddenNodeNameInput;
